import { render, staticRenderFns } from "./addUserInfo.vue?vue&type=template&id=74ca4bac&scoped=true&"
import script from "./addUserInfo.vue?vue&type=script&lang=js&"
export * from "./addUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./addUserInfo.vue?vue&type=style&index=0&id=74ca4bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca4bac",
  null
  
)

export default component.exports